<template>
  <div class="attention">
    <Header></Header>
    <img style="margin-top:60px" src="../../assets/paper/subimit.png" alt>
    <div style="color:red">{{message}}</div>
    <div class="back" v-if="isshow" @click="back">返回考试列表</div>
  </div>
</template>
<script>
import Header from "../../components/header";
export default {
  components: {
    Header
  },
  data() {
    return {
      message: null,
      isshow: true
    };
  },
  mounted() {
    if (this.$route.params.message) {
      this.message = this.$route.params.message.examcue
        ? this.$route.params.message.examcue
        : this.$route.params.message;
    }
    if (window.sessionStorage.getItem("type") == "2") {
      this.isshow = false;
    }
  },
  methods: {
    back() {
      this.$router.push("/examlists");
    }
  }
};
</script>
<style lang="css" scoped>
.attention {
  text-align: center;
}
.back {
  width: 1.4rem;
  height: 0.3rem;
  border-radius: 0.03rem;
  color: #fff;
  background: #5b61ff;
  font-size: 0.16rem;
  line-height: 0.3rem;
  margin: 0.22rem auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/testlists/submit.vue